// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import type { MediumIconProps } from 'tailwind/components/Icon/Icon.types';

const UtilityDottedFilterMediumIcon = (props: MediumIconProps) => (
  <Icon {...props} viewBox="0 0 32 32">
    <path
      d="M3.33325 7.46669H7.59992M7.59992 7.46669C7.59992 8.64488 8.55507 9.60004 9.73326 9.60004H11.8666C13.0448 9.60004 13.9999 8.64489 13.9999 7.46671C13.9999 6.28852 13.0448 5.33337 11.8666 5.33337H9.73326C8.55507 5.33337 7.59992 6.28851 7.59992 7.46669ZM18.2666 7.46669H28.5066M3.33325 16H18.2666M18.2666 16C18.2666 17.1782 19.2217 18.1334 20.3999 18.1334H22.5333C23.7114 18.1334 24.6666 17.1782 24.6666 16M18.2666 16C18.2666 14.8219 19.2217 13.8667 20.3999 13.8667H22.5333C23.7114 13.8667 24.6666 14.8219 24.6666 16M24.6666 16H28.5066M3.33325 24.5334H7.59992M7.59992 24.5334C7.59992 25.7116 8.55507 26.6667 9.73326 26.6667H11.8666C13.0448 26.6667 13.9999 25.7116 13.9999 24.5334M7.59992 24.5334C7.59992 23.3552 8.55507 22.4001 9.73326 22.4001H11.8666C13.0448 22.4001 13.9999 23.3552 13.9999 24.5334M13.9999 24.5334H28.5066"
      stroke="currentcolor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default UtilityDottedFilterMediumIcon;
